function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M276.4 269.3H7.1l134.6-256 134.7 256zm-222-28.4h174.8L141.7 73.5 54.4 240.9zm73.2-113.3h28.3v56.7h-28.3v-56.7zm14.2 63.7c3.4-.1 6.8.6 9.8 2.4 5.4 3.2 8.3 9.6 7.8 16.8-.7 10.4-7.5 15.7-16.2 16.2-2.8.2-5.6-.1-8.3-1-6-2.2-9.7-6.5-10.6-13.4-.8-5.7.1-11 3.8-15.4 3.3-3.9 7.7-5.3 12.4-5.5.4-.1.8-.1 1.3-.1z"
})));